import React from "react";
import { Collapse } from "reactstrap";

export default function NaviFaqItems(props) {
  const toggleCollapse = (index) => {
    props.toggle(index);
  }

  const redirect = () => {
    props.redirect('invest')
  }

  return (
    <React.Fragment>
      {props.faqs &&
        props.faqs.length &&
        props.faqs.map((item, index) => {
          return (
            props.isOrobonds && item.id === '3' ? null : <div className="faq-each-item">
              
              <div
                id={item.id}
                style={index === 0 && !props.bordered ? { border: "none" } : {}}
                className={
                  "question " +
                  (props.answer[index]
                    ? "border-bottom-none"
                    : "")
                }
                onClick={() => toggleCollapse(index)}
              >
                {item.question}
                <img
                  className={
                    "w-auto " +
                    (props.answer[index]
                      ? "down-arrow mb-1 ml-2"
                      : "ml-2")
                  }
                  src={process.env.REACT_APP_IMAGES_PATH + "rightArrow.webp"}
                />
              </div>
              <div>
                <Collapse
                  isOpen={props.answer[index]}
                  key={index}
                >
                  <div className="answer-div">
                    {item.answer &&
                      item.answer.length &&
                      item.answer.map((i, index) => {
                        if (i.question) {
                          if (Array.isArray(i.answer)) {
                            return (<div className="answer">
                              <p className="font-weight-semi-bold">{i.question}</p>
                              <ul>
                              {i.answer.map(ans => (
                                <li>{ans}</li>
                              ))}
                              </ul>
                            </div>)
                          } else{
                            if (i.id === 'redirect') {
                              return <div className="answer">
                                <p className="font-weight-semi-bold">{i.question}</p>
                                <div
                                  className="answer"
                                  onClick={redirect}
                                  dangerouslySetInnerHTML={{__html: i.answer}} 
                                  style={{cursor: 'pointer'}}
                                  />
                            </div>
                            }
                            return (<div className="answer">
                                <p className="font-weight-semi-bold">{i.question}</p>
                                <div className="answer" dangerouslySetInnerHTML={{__html: i.answer}} />
                            </div>)
                          }
                            
                        } else {
                        return <div className="answer" dangerouslySetInnerHTML={{__html: i}} />;
                        }
                      })}
                  </div>
                </Collapse>
              </div>
            </div>
          );
        })}
    </React.Fragment>
  );
}
